import { useWindowSize } from '@hooks/useWindowSize';

export const useModalDimensions = () => {
	const size = useWindowSize();

	const getModalDimensions = () => {
		const dimensions = [
			{ max: 375, width: '300px', height: '500px' },
			{ max: 430, width: '350px', height: '500px' },
			{ max: 576, width: '400px', height: '500px' },
			{ max: 768, width: '600px', height: '700px' },
			{ max: 992, width: '800px', height: '800px' },
			{ max: 1200, width: '900px', height: '850px' },
			{ max: Infinity, width: '1000px', height: '900px' },
		];

		return dimensions.find((d) => size.width <= d.max) || dimensions[dimensions.length - 1];
	};

	return getModalDimensions();
};
